export const pageLoadDataLayer = (
  pageName,
  paCode,
  deviceType,
  timeStampPL,
  siteSection = "emp:dealer connection",
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      pageName,
      siteSection,
      hierarchy: pageName,
      userLanguage: "eng",
      pageNameNoVehicle: pageName,
      client,
      site,
      radUIVersion: deviceType,
      timeStampPL,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
  };
};

export const pageLoadDetailDataLayer = (
  pageName,
  tool,
  orderId,
  paCode,
  deviceType,
  timeStampPL,
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  const toolDescriptor = `${tool}:${orderId}`;

  return {
    page: {
      pageName,
      siteSection: "emp:dealer connection",
      hierarchy: pageName,
      userLanguage: "eng",
      pageNameNoVehicle: pageName,
      client,
      site,
      tool,
      toolDescriptor,
      radUIVersion: deviceType,
      timeStampPL,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    event: {
      action: "tool",
    },
  };
};

export const customerHandlingPageLoadDetailDataLayer = (
  pageName,
  pageNameNoVehicle,
  tool,
  toolDescriptor,
  paCode,
  deviceType,
  timeStampPL,
  modelYear,
  nameplate,
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      pageName,
      siteSection: "emp:dealer connection",
      hierarchy: pageName,
      userLanguage: "eng",
      pageNameNoVehicle: pageNameNoVehicle,
      client,
      site,
      tool,
      toolDescriptor,
      radUIVersion: deviceType,
      timeStampPL,
    },
    vehicle: {
      modelYear,
      nameplate,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    event: {
      action: "tool",
    },
  };
};

export const onClickDataLayer = (
  pageName,
  onclick,
  onclickLinkName,
  paCode,
  deviceType,
  timeStampCTA,
  siteSection = "emp:dealer connection",
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      siteSection,
      userLanguage: "eng",
      client,
      site,
      radUIVersion: deviceType,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    onclick: {
      onclick,
      onclickLinkName,
      timeStampCTA,
    },
  };
};

export const onClickDetailDataLayer = (
  pageName,
  tool,
  toolDescriptor,
  orderId,
  onclick,
  onclickLinkName,
  paCode,
  deviceType,
  timeStampCTA,
  modelYear,
  nameplate,
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      siteSection: "emp:dealer connection",
      userLanguage: "eng",
      client,
      site,
      tool,
      toolDescriptor,
      radUIVersion: deviceType,
    },
    ...(modelYear &&
      nameplate && {
        vehicle: {
          modelYear,
          nameplate,
        },
      }),
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    onclick: {
      onclick,
      onclickLinkName,
      timeStampCTA,
    },
    event: {
      action: "tool",
    },
  };
};

export const onClickDetailDataLayerWithPaymentType = (
  pageName,
  tool,
  toolDescriptor,
  orderId,
  onclick,
  onclickLinkName,
  paCode,
  deviceType,
  timeStampCTA,
  paymentType,
  modelYear,
  nameplate,
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      siteSection: "emp:dealer connection",
      userLanguage: "eng",
      client,
      site,
      tool,
      toolDescriptor,
      radUIVersion: deviceType,
    },
    vehicle: {
      modelYear,
      nameplate,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    onclick: {
      onclick,
      onclickLinkName,
      timeStampCTA,
    },
    event: {
      action: "tool",
    },
    cart: {
      paymentMethod: paymentType,
    },
  };
};

export const onboardingOnClickDataLayer = (
  pageName,
  onclick,
  onclickLinkName,
  paCode,
  deviceType,
  timeStampCTA,
  eventAction,
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      siteSection: "emp:nvc",
      userLanguage: "eng",
      client,
      site,
      radUIVersion: deviceType,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    onclick: {
      onclick,
      onclickLinkName,
      timeStampCTA,
    },
    event: {
      action: eventAction,
    },
  };
};

export const internalReferralExitDataLayer = (
  onclick,
  onclickLinkName,
  paCode,
  deviceType,
  timeStampCTA,
  referredTo,
  siteSection = "emp:dealer connection",
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      siteSection,
      userLanguage: "eng",
      client,
      site,
      radUIVersion: deviceType,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    onclick: {
      onclick,
      onclickLinkName,
      referredTo,
      timeStampCTA,
    },
    event: {
      action: "brand referral",
    },
  };
};

export const referralExitDataLayer = (
  orderId,
  onclick,
  onclickLinkName,
  paCode,
  deviceType,
  timeStampCTA,
  siteSection = "emp:dealer connection",
  client = "ford-us",
  site = "fordvehicles.com"
) => {
  return {
    page: {
      siteSection,
      userLanguage: "eng",
      client,
      site,
      ...(orderId && {
        tool: "emp:order id",
        toolDescriptor: `emp:order id:${orderId}`,
      }),
      radUIVersion: deviceType,
    },
    user: {
      paCode,
      fordRegion: "",
      fdafCode: "",
      loginStatus: "logged in",
    },
    onclick: {
      onclick,
      onclickLinkName,
      timeStampCTA,
    },
    ...(orderId && {
      event: {
        action: "tool",
      },
    }),
  };
};
